import '../stylesheets/loader.css';

function Loader() {
  return (
    <div className="flex justify-center p-5">
      <div className="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
export default Loader;
